import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { programacionAcademicaMapper } from '@/mappers';
import { loadAbort, buildStrapiUrl } from '@/utils';
import type { StrapiSingleResponseModel, ProgramacionAcademicaPageModel } from '@/interfaces/model';
import type { ProgramacionAcademicaPage, StrapiBaseRequest } from '@/interfaces/strapi';

export const getProgramacionAcademica = (params: StrapiBaseRequest): UseApiCall<ProgramacionAcademicaPage> => {
	const controller = loadAbort();

	const { populate } = params ?? {};

	const url = buildStrapiUrl({
		base: '/programacion-academica',
		populate,
	});

	return {
		call: strapiInstance.get<ProgramacionAcademicaPage>(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const parsed = JSON.parse(raw) as StrapiSingleResponseModel<ProgramacionAcademicaPageModel>;
					return programacionAcademicaMapper(parsed.data);
				},
			],
		}),
		controller,
	};
};
